export const SHIELDS = [
  { name: 'なし', value: 0 },
  { name: 'かわのたて', value: 4 },
  { name: 'はがねのたて', value: 10 },
  { name: 'ちからのたて', value: 18 },
  { name: 'ロトのたて', value: 30 },
  { name: 'しにがみのたて', value: 40 }
]
